module.exports = __webpack_public_path__ + "img/downloadIcon.1940117a.svg";